import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';


// **
// Uses SessionStorage for saving user preference data that isn't sensitive/secure in nature
// **
@Injectable({
    providedIn: 'root'
  })
export class StorageService {

    constructor() {
    }
    private STORE_ID = environment.StorageID;

    public getPendoUserId(): string {
        const id = sessionStorage.getItem(environment.PendoUserID);
        return id;
    }

    public getUserHospitalId(): string {
        const id = sessionStorage.getItem(environment.HospitalId);
        return id;
    }

    public getUserHospitalName(): string {
        const name = sessionStorage.getItem(environment.HospitalName);
        return name;
    }

    public getUnitId(): string {
        const id = sessionStorage.getItem(environment.UnitId);
        return id;
    }
    public setUnitId(unitid: string) {
        sessionStorage.setItem(environment.UnitId, unitid);
    }

    public getIndicatorId(): string {
        const id = sessionStorage.getItem(environment.IndicatorId);
        return id;
    }
    public setIndicatorId(indid: string) {
        sessionStorage.setItem(environment.IndicatorId, indid);
    }

    public getSubscription(): number {
        return -1;
      }        
      
      public getSubscriptionsAvailable(): string {
        let subs = sessionStorage.getItem(environment.TokenSubscriptionsAvailable);
        subs = (subs === null) ? "" : subs;
        return subs;
      }
      
}
